import RegisterPersonalDataError from './RegisterPersonalDataError';
class InvalidBirthState extends RegisterPersonalDataError {
    constructor(birthState, options) {
        super(`Can not register birth state: ${birthState}`, options);
    }
}
export default InvalidBirthState;
